import axios from 'axios';
import { ExclamationIcon, TrashIcon } from '@heroicons/react/solid';
import Modal from 'components/Modal';
import ConfirmationModal from 'components/ConfirmationModal';
import { useState } from 'react';
import { dateFormatter } from 'utils/formatters';
import PlanAddonsTable from './PlanAddonsTable';
import ModalHeader from 'components/ModalHeader';
import useAlert from 'hooks/useAlert';
import { useDispatch } from 'react-redux';
import { fetchScheduledChanges } from '../subscriptionSlice';

const ScheduledChanges = ({
  open,
  setOpen,
  subscription,
  scheduledChanges,
}) => {
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const { alertSuccess, alertError } = useAlert();
  const dispatch = useDispatch();

  const dropChanges = async () => {
    setIsOpenConfirm(false);
    try {
      await axios.delete(
        `subscriptions/${subscription.subscription_id}/scheduledchanges`
      );

      alertSuccess(
        'Dropped changes for this subscription',
        `Scheduled changes has been dropped successfully`
      );
      dispatch(fetchScheduledChanges(subscription.subscription_id));
    } catch (error) {
      alertError('Drop changes failed', error.response.data.message);
    } finally {
      setOpen(false);
    }
  };

  return (
    <div className="sm:mx-5 ">
      <div className="flex items-center text-sm font-normal text-yellow-400 pt-3 px-5 border-t">
        <ExclamationIcon className="w-5 h-5 mr-1" /> There are some changes
        scheduled on&nbsp;
        {dateFormatter(scheduledChanges.subscription.next_billing_at)}.
        <button
          onClick={() => setOpen(true)}
          className="ml-1 text-red-500 tracking-widest font-bold text-xs"
        >
          View Changes
        </button>
      </div>
      <Modal align="top" open={open} setOpen={setOpen}>
        <div className="inline-block w-full max-w-3xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-xl">
          <ModalHeader
            title={`Changes will be effective from ${dateFormatter(
              scheduledChanges.subscription.next_billing_at
            )}.`}
            setOpen={setOpen}
            titleClasses="capitalize"
            border=""
            fontSize="text-xl"
            fontStyle="font-bold"
            px="px-4 md:px-8"
            py="py-4 md:py-8"
          />
          <div className="p-4">
            <PlanAddonsTable
              subscription={scheduledChanges.subscription}
              isScheduledChanges={1}
            />
          </div>

          <div className="px-6 py-4 mt-4 mb-8 flex justify-between">
            <button
              type="button"
              className="flex items-center text-sm text-red-500"
              onClick={() => setIsOpenConfirm(true)}
            >
              <TrashIcon className="w-4 h-4" />
              &nbsp;drop the scheduled changes
            </button>
          </div>
          <ConfirmationModal
            title="Drop Scheduled Changes"
            content="Are you sure you want to continue this action?"
            open={isOpenConfirm}
            setOpen={setIsOpenConfirm}
            onOkClick={dropChanges}
            onCancelClick={() => setIsOpenConfirm(false)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ScheduledChanges;
